module.exports = __webpack_public_path__ + "img/sports-betradar.174f932d.png";